import {Client, Lobby} from 'boardgame.io/react';
import {BattleCardGameRule} from "./GameRule";
import CardChessBoard from "./CardChessBoard";
import React from "react";

// const url = `http://${window.location.hostname}:8000`;
const url = `http://cardapi.yuiffy.com`;
// 这里http://不能省略成// ， 否则里面的socket.io连接时用的端口号会不对，会用成前端跑的端口比如3000
const OnlineVs = () => (
  <div>
    <Lobby
      gameServer={url}
      lobbyServer={url}
      gameComponents={[
        { game: BattleCardGameRule, board: CardChessBoard }
      ]}
    />
  </div>
);

export default OnlineVs;
